import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TitleBarComponent } from './title-bar.component';

@NgModule({
  imports: [CommonModule, NgOptimizedImage],
  declarations: [TitleBarComponent],
  exports: [TitleBarComponent]
})
export class TitleBarModule {}
